import { useEffect } from 'react';

import { Box, Button } from '@mui/material';

import AddApp from '@/assets/icons/AddApp';
import Typography from '@/components/Typography';
import { useEditDashboardDraft } from '@/features/Dashboard/context/EditDashboardDraft';
import { DrawerStep, useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';

import { AddAppButton } from './components/AddAppButton';
import { DashboardLayout } from '../../components/DashboardLayout';

export const EmptyDashboard = () => {
  const { setDrawerStep } = useDrawerSteps();
  const { dashboardName } = useEditDashboardDraft();

  const onClick = () => {
    setDrawerStep(DrawerStep.SelectApp);
  };

  const { setMode } = useAppForm();

  useEffect(() => {
    setMode('create');
  }, []);

  return (
    <DashboardLayout title={dashboardName}>
      <Box
        sx={{
          mt: 2,
          marginBottom: 1,
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography
          fontWeight='bold'
          size={24}
          textAlign='center'
        >
          Start Building Your Dashboard
        </Typography>
        <Typography
          size={20}
          sx={{
            mb: 1
          }}
          textAlign='center'
        >
          Organize your perfect workspace by adding apps
        </Typography>
        <Button
          size='large'
          variant='contained'
          onClick={onClick}
        >
          <AddApp
            fill='#F8F8F8'
            sx={{
              width: '24px',
              height: '24px'
            }}
          />
          <Box
            sx={{
              marginLeft: '8px'
            }}
          >
            Add Your First App
          </Box>
        </Button>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gap: {
            xs: 1,
            md: 3
          },
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(2, 1fr)'
          },
          width: '100%'
        }}
      >
        <AddAppButton onClick={onClick} />
        <AddAppButton onClick={onClick} />
      </Box>
    </DashboardLayout>
  );
};
